<template>
  <div class="widget-heading pb-0 d-block">
    <div class="row">
      <!-- Duży ekran -->
      <div class="col-md-12 btn-group d-none d-md-flex">
        <Link :href="route('production.out.index')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('production.out.index') }">Zamówienia zewnętrzne</Link>
        <Link :href="route('producents.out.index')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('producents.out.index') }">Kontrahenci</Link>
        <Link :href="route('production.out.statusy')" class="btn btn-outline-primary" :class="{ 'btn-primary': isRouteActive('production.out.statusy') }">Statusy</Link>
    </div>

      <div class="col-12 d-md-none">
        <div class="dropdown">
		  <button class="btn btn-outline-primary dropdown-toggle w-100 d-flex align-items-center justify-content-between" type="button" @click="toggleDropdown">
		  {{ activeLabel }}
		  <i class="bi bi-list ms-2"></i>
		  </button>
          <div class="dropdown-menu w-100" :class="{ show: isDropdownOpen }">
            <Link :href="route('production.out.index')" class="dropdown-item" :class="{ 'active': isRouteActive('production.out.index') }">Zamówienia zewnętrzne</Link>
            <Link :href="route('producents.out.index')" class="dropdown-item" :class="{ 'active': isRouteActive('producents.out.index') }">Kontrahenci</Link>
            <Link :href="route('production.out.statusy')" class="dropdown-item" :class="{ 'active': isRouteActive('production.out.statusy') }">Statusy</Link>
         </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";

export default {
  setup() {
    const isDropdownOpen = ref(false);

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const isRouteActive = (routeName) => {
      return route().current(routeName);
    };

    // mapowanie trasa -> etykieta
    const labels = {
      "production.out.index": "Zamówienia zewnętrzne",
      "producents.out.index": "Kontrahenci",
      "production.out.statusy": "Statusy",
    };

    const activeLabel = computed(() => {
      const current = route().current();
      return labels[current] || "Menu";
    });

    return {
      route,
      isRouteActive,
      isDropdownOpen,
      toggleDropdown,
      activeLabel,
    };
  },
};
</script>
